export const malayalamFlashcards = {
  categories: [
    {
      ml: "നമസ്കാരം",
      rm: "Namaskaaram",
      en: "Hello / Greetings",
    },
    {
      ml: "സുഖമാണോ?",
      rm: "Sukhamano?",
      en: "How are you? (formal)",
    },
    {
      ml: "എന്തൊക്കെയുണ്ട് വിശേഷം?",
      rm: "Enthokkeyundu vishesham?",
      en: "What's new? / What's up?",
    },
    {
      ml: "എല്ലാം സുഖം",
      rm: "Ellaam sukham",
      en: "All is well / I'm fine",
    },
    {
      ml: "നന്ദി",
      rm: "Nandi",
      en: "Thank you",
    },
    {
      ml: "വളരെ നന്ദി",
      rm: "Valare nandi",
      en: "Thank you very much",
    },
    {
      ml: "സാരമില്ല",
      rm: "Saaramilla",
      en: "You're welcome / It's okay / Never mind",
    },
    {
      ml: "ക്ഷമിക്കണം",
      rm: "Shamikkane",
      en: "Excuse me / Sorry",
    },
    {
      ml: "ദയവായി",
      rm: "Dayavaayi",
      en: "Please",
    },
    {
      ml: "ഉവ്വ്",
      rm: "Uvvŭ",
      en: "Yes",
    },
    {
      ml: "ഇല്ല",
      rm: "Illa",
      en: "No",
    },
    {
      ml: "ശരി",
      rm: "Shari",
      en: "Okay / Alright",
    },
    {
      ml: "എനിക്ക് മനസ്സിലായില്ല",
      rm: "Enikku manassilaayilla",
      en: "I don't understand",
    },
    {
      ml: "നിങ്ങൾക്ക് ഇംഗ്ലീഷ് അറിയാമോ?",
      rm: "Ningalkku English ariyaamo?",
      en: "Do you know English?",
    },
    {
      ml: "ഇതെന്താണ്?",
      rm: "Ithenthaanu?",
      en: "What is this?",
    },
    {
      ml: "ഇതിന് എത്രയാണ് വില?",
      rm: "Ithinu ethrayaanu vila?",
      en: "How much is this?",
    },
    {
      ml: "എവിടെയാണ്?",
      rm: "Evideyaanu?",
      en: "Where is...?",
    },
    {
      ml: "ടോയ്‌ലറ്റ് എവിടെയാണ്?",
      rm: "Toilet evideyaanu?",
      en: "Where is the toilet?",
    },
    {
      ml: "റെയിൽവേ സ്റ്റേഷൻ എവിടെയാണ്?",
      rm: "Railway station evideyaanu?",
      en: "Where is the railway station?",
    },
    {
      ml: "എയർപോർട്ട് എവിടെയാണ്?",
      rm: "Airport evideyaanu?",
      en: "Where is the airport?",
    },
    {
      ml: "ആശുപത്രി എവിടെയാണ്?",
      rm: "Aashupathri evideyaanu?",
      en: "Where is the hospital?",
    },
    {
      ml: "സഹായിക്കൂ!",
      rm: "Sahaayikkuu!",
      en: "Help!",
    },
    {
      ml: "പോലീസ്!",
      rm: "Police!",
      en: "Police!",
    },
    {
      ml: "എനിക്ക് സഹായം വേണം",
      rm: "Enikku sahaayam venam",
      en: "I need help",
    },
    {
      ml: "ഞാൻ വഴിതെറ്റിപ്പോയി",
      rm: "Njaan vazhi thettippoyi",
      en: "I am lost",
    },
    {
      ml: "നിങ്ങൾക്ക് എന്നെ സഹായിക്കാമോ?",
      rm: "Ningalkku enne sahaayikkaamo?",
      en: "Can you help me?",
    },
    {
      ml: "മെല്ലെ പറയൂ",
      rm: "Melle parayuu",
      en: "Speak slowly",
    },
    {
      ml: "ഒന്നുകൂടി പറയൂ",
      rm: "Onnukoodi parayuu",
      en: "Say it again",
    },
    {
      ml: "എനിക്ക് സുഖമില്ല",
      rm: "Enikku sukhamilla",
      en: "I am not feeling well / I am sick",
    },
    {
      ml: "എനിക്ക് ഒരു ഡോക്ടറെ കാണണം",
      rm: "Enikku oru doctore kaananum",
      en: "I need to see a doctor",
    },
    {
      ml: "ഇത് വളരെ വിലകൂടിയതാണ്",
      rm: "Ithu valare vilakoodiyathaanu",
      en: "This is too expensive",
    },
    {
      ml: "കുറയ്ക്കാമോ?",
      rm: "Kuraykkaamo?",
      en: "Can you lower the price?",
    },
    {
      ml: "എനിക്കിത് വേണം",
      rm: "Enikkithu venam",
      en: "I want this",
    },
    {
      ml: "എനിക്കിത് വേണ്ട",
      rm: "Enikkithu venda",
      en: "I don't want this",
    },
    {
      ml: "എൻ്റെ പേര് ... ആണ്",
      rm: "Ente peru ... aanu",
      en: "My name is...",
    },
    {
      ml: "നിങ്ങൾക്ക് എങ്ങനെയുണ്ട്?",
      rm: "Ningalkku enganeyundu?",
      en: "How are you? (formal)",
    },
    {
      ml: "എന്തൊക്കെയുണ്ട്?",
      rm: "Enthokkeyundu?",
      en: "What's up? (informal)",
    },
    {
      ml: "ഞാൻ സുഖമായിരിക്കുന്നു, നന്ദി",
      rm: "Njaan sukhamaayirikkunnu, nandi",
      en: "I am fine, thank you",
    },
    {
      ml: "നല്ലത്",
      rm: "Nallathu",
      en: "Good",
    },
    {
      ml: "വളരെ നല്ലത്",
      rm: "Valare nallathu",
      en: "Very good",
    },
    {
      ml: "മോശം",
      rm: "Mosham",
      en: "Bad",
    },
    {
      ml: "സുപ്രഭാതം",
      rm: "Suprabhaatham",
      en: "Good morning",
    },
    {
      ml: "ശുഭദിനം",
      rm: "Shubhadinam",
      en: "Good day",
    },
    {
      ml: "ശുഭ സായാഹ്നം",
      rm: "Shubha saayaahnam",
      en: "Good evening",
    },
    {
      ml: "ശുഭ രാത്രി",
      rm: "Shubha raathri",
      en: "Good night",
    },
    {
      ml: "പോയി വരൂ",
      rm: "Poyi varuu",
      en: "Goodbye",
    },
    {
      ml: "വീണ്ടും കാണാം",
      rm: "Veendum kaanaam",
      en: "See you again",
    },
    {
      ml: "വലത്തേക്ക്",
      rm: "Valathekkŭ",
      en: "To the right",
    },
    {
      ml: "ഇടത്തേക്ക്",
      rm: "Idathekkŭ",
      en: "To the left",
    },
    {
      ml: "നേരെ",
      rm: "Nere",
      en: "Straight ahead",
    },
    {
      ml: "മുകളിൽ",
      rm: "Mukalil",
      en: "Up",
    },
    {
      ml: "താഴെ",
      rm: "Thazhe",
      en: "Down",
    },
    {
      ml: "അടുത്ത്",
      rm: "Aduththŭ",
      en: "Near",
    },
    {
      ml: "ദൂരെ",
      rm: "Doore",
      en: "Far",
    },
    {
      ml: "ഇന്ന്",
      rm: "Innu",
      en: "Today",
    },
    {
      ml: "നാളെ",
      rm: "Naale",
      en: "Tomorrow",
    },
    {
      ml: "ഇന്നലെ",
      rm: "Innale",
      en: "Yesterday",
    },
    {
      ml: "ഇപ്പോൾ",
      rm: "Ippol",
      en: "Now",
    },
    {
      ml: "പിന്നീട്",
      rm: "Pinneedŭ",
      en: "Later",
    },
    {
      ml: "രാവിലെ",
      rm: "Raavile",
      en: "Morning",
    },
    {
      ml: "ഉച്ചയ്ക്ക്",
      rm: "Uchchakku",
      en: "Afternoon",
    },
    {
      ml: "വൈകുന്നേരം",
      rm: "Vaikunneram",
      en: "Evening",
    },
    {
      ml: "രാത്രി",
      rm: "Raathri",
      en: "Night",
    },
    {
      ml: "വെള്ളം",
      rm: "Vellam",
      en: "Water",
    },
    {
      ml: "ഭക്ഷണം",
      rm: "Bhakshanam",
      en: "Food",
    },
    {
      ml: "ചായ",
      rm: "Chaaya",
      en: "Tea",
    },
    {
      ml: "കാപ്പി",
      rm: "Kaappi",
      en: "Coffee",
    },
    {
      ml: "ബിയർ",
      rm: "Biyar",
      en: "Beer",
    },
    {
      ml: "മദ്യം",
      rm: "Madyam",
      en: "Alcohol",
    },
    {
      ml: "സസ്യാഹാരം",
      rm: "Sasyaahaaram",
      en: "Vegetarian",
    },
    {
      ml: "മാംസാഹാരം",
      rm: "Maamsaahaaram",
      en: "Non-vegetarian",
    },
    {
      ml: "ഇത് സസ്യാഹാരമാണോ?",
      rm: "Ithu sasyaahaaramaano?",
      en: "Is this vegetarian?",
    },
    {
      ml: "എനിക്ക് വിശക്കുന്നു",
      rm: "Enikku vishakkunnu",
      en: "I am hungry",
    },
    {
      ml: "എനിക്ക് ദാഹിക്കുന്നു",
      rm: "Enikku daahikkunnu",
      en: "I am thirsty",
    },
    {
      ml: "എത്ര സമയമെടുക്കും?",
      rm: "Ethra samayamedukkum?",
      en: "How much time will it take?",
    },
    {
      ml: "പാസ്പോർട്ട്",
      rm: "Passport",
      en: "Passport",
    },
    {
      ml: "വിസ",
      rm: "Visa",
      en: "Visa",
    },
    {
      ml: "ടിക്കറ്റ്",
      rm: "Ticket",
      en: "Ticket",
    },
    {
      ml: "ഹോട്ടൽ",
      rm: "Hotel",
      en: "Hotel",
    },
    {
      ml: "മുറി",
      rm: "Muri",
      en: "Room",
    },
    {
      ml: "എനിക്ക് ഒരു മുറി ബുക്ക് ചെയ്യണം",
      rm: "Enikku oru muri book cheyyanam",
      en: "I want to book a room",
    },
    {
      ml: "ഇത് വളരെ നല്ലതാണ്",
      rm: "Ithu valare nallathaanu",
      en: "This is very good",
    },
    {
      ml: "ഇത് വളരെ മോശമാണ്",
      rm: "Ithu valare moshamanu",
      en: "This is very bad",
    },
    {
      ml: "പ്രശ്നമില്ല",
      rm: "Prashnamilla",
      en: "No problem",
    },
    {
      ml: "ആശംസകൾ",
      rm: "Aashamsakal",
      en: "Best wishes / Congratulations",
    },
    {
      ml: "സന്തോഷമായിരിക്കൂ",
      rm: "Santhoshamaayirikkuu",
      en: "Have fun",
    },
    {
      ml: "കഴിയു",
      rm: "Kazhiyu",
      en: "Please come in/have it",
    },
    {
      ml: "വേഗം വരൂ",
      rm: "Vegang varuu",
      en: "Come quickly",
    },
    {
      ml: "ഇവിടെ വരൂ",
      rm: "Ivade varuu",
      en: "Come here",
    },
    {
      ml: "ഇരിക്കൂ",
      rm: "Irikkuu",
      en: "Sit",
    },
    {
      ml: "ഒന്ന് നോക്കു",
      rm: "Onnu nokku",
      en: "Have a look",
    },
  ],
};
